import { useEffect } from 'react'
import { Box, Button } from '@mui/material'
import { useTranslation } from 'react-i18next'

const normalizeLanguage = lang => (lang || '').toLowerCase().startsWith('fr') ? 'fr' : 'en'

const LanguageDropdown = ({ settings, saveSettings }) => {
  const { i18n } = useTranslation()
  const { direction } = settings
  const activeLang = normalizeLanguage(i18n.resolvedLanguage || i18n.language)

  useEffect(() => {
    if (i18n.language !== activeLang) {
      i18n.changeLanguage(activeLang)
    }
    if (direction !== 'ltr') {
      saveSettings({ ...settings, direction: 'ltr' })
    }
  }, [activeLang, direction, i18n, saveSettings, settings])

  const handleLanguageChange = lang => {
    i18n.changeLanguage(lang)
    if (direction !== 'ltr') {
      saveSettings({ ...settings, direction: 'ltr' })
    }
  }

  const buttonStyles = isActive => ({
    minWidth: 42,
    height: 34,
    px: 1.5,
    borderRadius: '18px',
    border: isActive ? '1px solid #FC5722' : '1px solid transparent',
    color: isActive ? '#fff' : '#6C7278',
    bgcolor: isActive ? '#FC5722' : 'transparent',
    fontWeight: 700,
    fontSize: '12px',
    lineHeight: 1,
    '&:hover': {
      bgcolor: isActive ? '#e64a19' : '#f0f2f5'
    }
  })

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        p: 0.5,
        border: '1px solid #E7E9ED',
        borderRadius: '999px',
        bgcolor: '#F9FAFC'
      }}
    >
      <Button aria-label='Switch to English' onClick={() => handleLanguageChange('en')} sx={buttonStyles(activeLang === 'en')}>
        EN
      </Button>
      <Button aria-label='Switch to French' onClick={() => handleLanguageChange('fr')} sx={buttonStyles(activeLang === 'fr')}>
        FR
      </Button>
    </Box>
  )
}

export default LanguageDropdown
